import { createSelector } from 'reselect';

export const selectBuyOnlinePickupInstore = state => state.buyOnlinePickupInstore;
export const selectBuyOnlinePickupInstoreConfig = createSelector(
  selectBuyOnlinePickupInstore,
  buyOnlinePickupInstore => buyOnlinePickupInstore.config,
);

export const selectBuyOnlinePickupInstoreMerchants = createSelector(
  selectBuyOnlinePickupInstore,
  buyOnlinePickupInstore => buyOnlinePickupInstore.merchants,
);

export const selectBuyOnlinePickupInstoreIsLoaded = createSelector(
  selectBuyOnlinePickupInstore,
  buyOnlinePickupInstore => buyOnlinePickupInstore.isLoaded,
);

export const selectBuyOnlinePickupInstoreIsLoading = createSelector(
  selectBuyOnlinePickupInstore,
  buyOnlinePickupInstore => buyOnlinePickupInstore.isLoading,
);
